// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WL-w","newExpiryDate":"styles_newExpiryDate__2tT6U","footer":"styles_footer__1dIaC"};